import React from 'react';
import css from './LegalDocViewer.module.css';
import { LayoutSingleColumn, Page } from '../../components';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

const LegalDocViewer = ({ title = '', filePath = '', hideNavs = false }) => {
  return (
    <Page title={`ScanWow - ${title}`} description={title} scrollingDisabled={false}>
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        topbar={!hideNavs && <TopbarContainer />}
        footer={!hideNavs && <FooterContainer />}
      >
        <div className={css.wrapper}>
          <embed
            className={css.embededPdf}
            src={filePath}
            type="application/pdf"
            width="100%"
            height="100%"
          />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default LegalDocViewer;
